import { render, staticRenderFns } from "./ConversationWrapper.vue?vue&type=template&id=a0644c84"
import script from "./ConversationWrapper.vue?vue&type=script&lang=js"
export * from "./ConversationWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConversationWrapper.vue?vue&type=style&index=0&id=a0644c84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports